import { createSlice } from "@reduxjs/toolkit";

const basketSlice = createSlice({
    name: "track",
    initialState: {
        track: 0,
        isFetching: false,
        error: false,
    },
    reducers: {
        trackStart: (state) => {
            state.isFetching = true;
        },
        trackSuccess: (state, action) => {
            state.isFetching = false;
            state.track = action.payload;
        },
        trackFailure: (state) => {
            state.isFetching = false;
            state.error = true;
        }
    },
});

export const { trackStart, trackSuccess, trackFailure } = basketSlice.actions;
export default basketSlice.reducer;
